import * as Yup from 'yup';
import { Ticket } from '@features/tickets/interfaces/ticket';
import i18n from '@shared/config/i18n';
import {
  startDateAfterFinishDate,
  startDateAfterCurrentDate,
  requiredAmountInvoice,
  positiveAmountInvoice,
  maxValueAmountInvoice,
  requiredFileInvoice,
  requiredStatusInvoice,
  fieldsDateOneRequired,
  fieldsDateTwoRequired,
  fieldsResponsiblesRequired,
  fieldsPodryadRequired,
  fieldsPodryadEmployeeRequired,
  fieldsCleaningRequired,
} from '../../libs';
import {
  FEW_FIELDS_IDS,
  MANY_FIELDS_IDS,
} from '../../models/ticket/init-additional-fields-data';

const { t } = i18n;

const thisIsRequiredField = t('thisIsRequiredField');
const startDateBeforeEndDate = t('StartDateBeforeEndDate');
const startDateMustNotBeLaterThanTheCurrentDate = t(
  'StartDateMustNotBeLaterThanTheCurrentDate'
);
const endDateAfterStartDate = t('EndDateAfterStartDate');
const uploadInvoiceFile = t('UploadInvoiceFile');
const amountMustNotBeNegative = t('AmountMustNotBeNegative');
const maximumAmountExceeded = t('MaximumAmountExceeded');
const urlLengthMustBeLess = t('Max250Symbols');
const disablePast = t('disablePast');

export function disablePastIfNotUndefined(this: { parent: Ticket }) {
  if (this.parent.id) return true;
  if (this.parent.sla === undefined) return true;

  const slaSeconds = Number(new Date(this.parent.sla));
  const nowSeconds = Number(new Date());

  return slaSeconds > nowSeconds;
}

export const validationSchema = Yup.object().shape({
  class: Yup.mixed().required(thisIsRequiredField),
  description: Yup.string().required(thisIsRequiredField),
  priority: Yup.mixed().required(thisIsRequiredField),
  sla: Yup.mixed().test('sla-date-disable-past', disablePast, disablePastIfNotUndefined),
  origin: Yup.mixed().required(thisIsRequiredField),
  status: Yup.mixed().required(thisIsRequiredField),
  object: Yup.mixed().required(thisIsRequiredField),
  house: Yup.mixed().required(thisIsRequiredField),
  // initiator: Yup.mixed().test(
  //   'initiator-required',
  //   thisIsRequiredField,
  //   requiredInitiator
  // ),
  planned_start_at: Yup.mixed()
    .test(
      'start_date-after-finish_date',
      startDateBeforeEndDate,
      startDateAfterFinishDate
    )
    .test(
      'start-date-after-current-date',
      startDateMustNotBeLaterThanTheCurrentDate,
      startDateAfterCurrentDate
    ),
  planned_end_at: Yup.mixed().test(
    'start_date-after-finish_date',
    endDateAfterStartDate,
    startDateAfterFinishDate
  ),
  // type_repeat: Yup.mixed().test('type-required', thisIsRequiredField, requiredTypeRepeat),
  // every_repeat: Yup.mixed().test(
  //   'every-required',
  //   thisIsRequiredField,
  //   requiredEveryRepeat
  // ),
  expenses: Yup.array().of(
    Yup.object().shape({
      workTime: Yup.string().required(thisIsRequiredField),
      materials: Yup.array().of(
        Yup.object().shape({
          materialCount: Yup.string().required(thisIsRequiredField),
        })
      ),
    })
  ),
  invoices: Yup.array().of(
    Yup.object().shape(
      {
        file: Yup.mixed().when('url', {
          is: '',
          then: Yup.mixed().test('file-required', uploadInvoiceFile, requiredFileInvoice),
          otherwise: Yup.mixed().nullable(),
        }),
        amount: Yup.mixed()
          .test('amount-required', thisIsRequiredField, requiredAmountInvoice)
          .test('amount-positive', amountMustNotBeNegative, positiveAmountInvoice)
          .test('amount-max-value', maximumAmountExceeded, maxValueAmountInvoice),
        status: Yup.mixed().test(
          'status-required',
          thisIsRequiredField,
          requiredStatusInvoice
        ),
        url: Yup.string().when('file', {
          is: null,
          then: Yup.string().required(thisIsRequiredField).max(250, urlLengthMustBeLess),
          otherwise: Yup.string().nullable(),
        }),
      },
      ['file', 'url']
    )
  ),
  fields: Yup.object().shape({
    [MANY_FIELDS_IDS.dateOne]: Yup.mixed().test(
      'fields_date_one',
      thisIsRequiredField,
      fieldsDateOneRequired
    ),
    [MANY_FIELDS_IDS.dateTwo]: Yup.mixed().test(
      'fields_date_two',
      thisIsRequiredField,
      fieldsDateTwoRequired
    ),
    [MANY_FIELDS_IDS.responsibles]: Yup.mixed().test(
      'fields_responsibles',
      thisIsRequiredField,
      fieldsResponsiblesRequired
    ),
    // [MANY_FIELDS_IDS.responsibleTwo]: Yup.mixed().test(
    //   'fields_responsibles_two',
    //   thisIsRequiredField,
    //   fieldsResponsiblesTwoRequired
    // ),
    // [MANY_FIELDS_IDS.responsibleTwoFiles]: Yup.mixed().test(
    //   'fields_responsibles_two_files',
    //   thisIsRequiredField,
    //   fieldsResponsiblesTwoFilesRequired
    // ),
    [MANY_FIELDS_IDS.podryad]: Yup.mixed().test(
      'fields_podryad',
      thisIsRequiredField,
      fieldsPodryadRequired
    ),
    [MANY_FIELDS_IDS.podryadEmployeeFiles]: Yup.mixed().test(
      'fields_podryad_employee',
      thisIsRequiredField,
      fieldsPodryadEmployeeRequired
    ),
    [FEW_FIELDS_IDS.cleaning]: Yup.mixed().test(
      'fields_cleaning',
      thisIsRequiredField,
      fieldsCleaningRequired
    ),
  }),
});
